
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1C6.73 1 5 2 5 3.5v1.083c0 .23.224.417.5.417s.5-.187.5-.417V3.5C6 2.5 7.172 2 8 2c.828 0 2 .5 2 1.5v1.083c0 .23.224.417.5.417s.5-.187.5-.417V3.5C11 2 9.27 1 8 1zm4.554 5.52c-.06-.3-.383-.52-.765-.52h-7.58a.9.9 0 00-.502.148.597.597 0 00-.261.372L2 14.77c0 .326.163.64.453.87.29.231.685.361 1.095.361h8.904c.856 0 1.548-.55 1.548-1.231l-1.446-8.25z"}})])
          )
        }
      }
    